export { BUILD_COMMANDS, keywordEngine, route, takeoffText } from './engines/keyword';
export { lfm2Prompt, parseToolCalls, stripToolTokens, type ChatMessage } from './engines/lfm2';
export { localEngine, type Executor, type Generator, type LocalOptions } from './engines/local';
export {
  auditText,
  buildText,
  checkText,
  describeText,
  exportText,
  findingsText,
  queryText,
  renderLast,
  sceneText,
} from './engines/render';
export { SYSTEM_PROMPT, systemPrompt } from './prompt';
export {
  areaOf,
  isMixed,
  isType,
  materialNames,
  materialShare,
  num,
  prop,
  quantity,
  volumeOf,
  type Material,
  type MaterialLayer,
  type PropsElement,
  type PropsFile,
  type Storey,
  type VolumeSource,
} from './props';
export { unverifiedNumbers } from './provenance';
export {
  compare,
  fieldValue,
  makeTools,
  normalizeType,
  TOOL_SPECS,
  type Attachment,
  type Cell,
  type GroupBy,
  type Op,
  type TakeoffResult,
  type TakeoffSheet,
} from './tools';
export { callTool, effectsFrom, highlightsFrom, traceLine } from './trace';
export type {
  Answer,
  AskContext,
  Bounds,
  BuildStore,
  Engine,
  EngineName,
  SceneEffect,
  ToolCall,
  ToolFn,
  ToolSpec,
  Turn,
} from './types';
export {
  checkBuilding,
  RECIPES,
  type BuildParams,
  type BuildResult,
  type CheckOptions,
  type Finding,
  type Recipe,
} from './build';

export const SUGGESTED_QUESTIONS = [
  'How many cubic metres of concrete are in the model?',
  'Export the takeoff as Excel',
  'Colour everything by material',
  'Which doors have no fire rating?',
  'Put another floor on top',
  'Add a flat roof',
  'What changed since the original?',
];
